// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__rmvIa","tagButton":"styles_tagButton__FXhwJ","icon":"styles_icon__btBcw","label":"styles_label__ViGsx"};